(() => {
  const SELECTOR = 'swatches-variant-picker-component overflow-list';

  function forceShowAll(list) {
    const apply = () => {
      list.setAttribute('disabled', 'true');
      if (typeof list.showAll === 'function') {
        list.showAll();
      }
    };

    requestAnimationFrame(() => {
      apply();
      requestAnimationFrame(apply);
      setTimeout(apply, 120);
    });
  }

  function scan(root = document) {
    if (!root.querySelectorAll) return;

    root.querySelectorAll(SELECTOR).forEach((list) => {
      forceShowAll(list);

      if (list._swatchResizeObserverAttached) return;

      const ro = new ResizeObserver(() => forceShowAll(list));
      ro.observe(list);
      list._swatchResizeObserverAttached = true;
    });
  }

  function init() {
    scan();

    window.addEventListener('load', () => scan(), { once: true });
    window.addEventListener('resize', () => scan());

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => scan());
    }

    document.addEventListener('shopify:section:load', (event) => {
      scan(event.target || document);
    });

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) scan(node);
        });
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  customElements.whenDefined('overflow-list').then(init);
})();